module.exports = __webpack_public_path__ + "img/ico-buildings-list.7d4c7aad.svg";